export const FLASH = {
    subscribe_plan_error: 'subscribe_plan_error',
    email_confirmed: 'email_confirmed',
    plan_validation_error: 'plan_validation_error',
    paypal_payment_error: 'paypal_payment_error',
    gift_checkout_success_error: 'gift_checkout_success_error',
    gift_redeem_error: 'gift_redeem_error',
    common_dashboard_error: 'common_dashboard_error',
    unsupported_currency_error: 'unsupported_currency_error',
    profile_updated: 'profile_updated',
};
